import React, { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import { FormLabel } from '@spaceshipapp/cambridge';
import Logo from '../../components/Logo';
import { Header, LoginInput, FormWrapper, LoginFormControl, ErrorMessage } from './styled';
import auth from '../../apis/auth';
import { FormButton } from '../../components/FormButton';
import { Container } from '../../components/FormElements';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../../utils/auth';

const Login = (): React.ReactElement => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const submitUser = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setLoading(!loading);

    try {
      const result = await auth({ email, password });
      if (result) {
        setEmail('');
        setPassword('');
        setLoading(!loading);
        setError('');
        navigate('/form');
      } else {
        setError('Login email or password incorrect');
      }
    } catch (error) {
      setError('Login email or password incorrect');
      setLoading(false);
    }
  };

  useEffect(() => {
    function fetchToken() {
      const token = getToken();
      if (token) {
        navigate('/form');
      }
    }
    fetchToken();
  }, []);

  return (
    <>
      <Container>
        <FormWrapper onSubmit={(event: FormEvent<HTMLFormElement>) => submitUser(event)}>
          <Logo />
          <Header>LOGIN HERE</Header>
          <ErrorMessage>{error && error}</ErrorMessage>
          <LoginFormControl>
            <FormLabel>Email</FormLabel>
            <LoginInput
              required
              type="email"
              name="email"
              value={email}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                return setEmail(e.target.value);
              }}
            />
          </LoginFormControl>
          <LoginFormControl>
            <FormLabel>Password</FormLabel>
            <LoginInput
              required
              type="password"
              name="password"
              value={password}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                return setPassword(e.target.value);
              }}
            />
          </LoginFormControl>
          <FormButton variant="primary" size="sm" type="submit" loading={loading}>
            Login
          </FormButton>
        </FormWrapper>
      </Container>
    </>
  );
};

export default Login;
